import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { parseDailyrentBanner } from './parseDailyrentBanner';

interface IUseContentParams {
  canParse: boolean;
  postContent: string;
  setPostContent: Dispatch<SetStateAction<string>>;
  done(): void;
  options: { isEnabled: boolean };
}

/**
 * Заменяет маркер баннера посуточной аренды на пустой контейнер с id, если баннер
 * включён для статьи, иначе вырезает маркер. Сам DailyrentBanner монтируется
 * в контейнер отдельно (через React portal)
 */
export const useContentDailyrentBanner = ({
  canParse,
  postContent,
  setPostContent,
  done,
  options,
}: IUseContentParams) => {
  const { pathname } = useLocation();
  const [prevPathname, setPrevPathname] = useState(pathname);
  const [isParsed, setIsParsed] = useState(false);
  const [containerId, setContainerId] = useState<string | null>(null);

  /** Сбрасывает стэйт при клиентском переходе с поста на пост */
  useEffect(() => {
    if (pathname !== prevPathname) {
      setPrevPathname(pathname);
      setIsParsed(false);
      setContainerId(null);
    }
  }, [pathname, prevPathname]);

  /** Парсит маркер баннера */
  useEffect(() => {
    if (!canParse || isParsed) {
      return;
    }

    const { html, containerId: parsedContainerId } = parseDailyrentBanner(postContent, options.isEnabled);

    if (html !== postContent) {
      setPostContent(html);
    }

    setContainerId(parsedContainerId);
    setIsParsed(true);
    done();
  }, [canParse, done, isParsed, options.isEnabled, postContent, setPostContent]);

  return containerId;
};
